export default {"src":"/_next/static/media/arrow-left.785b7657.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};